import { useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { getTranslate } from '../../../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../../../utils/getLocatPath/getLocalPath';
import { isExternalLink } from '../../../../utils/isExternalLink/isExternalLink';
import styles from '../Header.module.scss';

export const Mobile = ({ upHeader, isMobMenu, setIsMobMenu, getFilterUrlLink }) => {
  const [numItem, setNumItem] = useState(false);
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const upMenu = upHeader.acf.menu;

  return (
    <nav className={`${styles.mobile} ${isMobMenu ? 'active' : ''}`}>
      <div className="container">
        <div className={styles.mobile_body}>
          <div className={styles.mobile_title}>{t('Мәзір', 'Меню', lang)}</div>
          <div className={styles.mobile_exit}>
            <div onClick={() => setIsMobMenu(false)} className={styles.mobile_exit_img}>
              <span></span>
            </div>
          </div>
          <div className={styles.mobile_content}>
            <ul className={styles.mobile_menu}>
              <li onClick={() => setIsMobMenu(false)} className={styles.mobile_menu_item}>
                <NavLink to={l('', lang)} className={styles.mobile_menu_text}>
                  {t('Негізгі', 'Главная', lang)}
                </NavLink>
              </li>
              {upMenu.map((el, idx) => {
                const { title, menu } = el;
                return (
                  <li key={idx} onClick={() => (idx === numItem ? setNumItem(false) : setNumItem(idx))} className={styles.mobile_menu_item}>
                    <div className={styles.mobile_menu_text}>
                      <span>{title[lang]}</span>
                      <span>▾</span>
                    </div>
                    <div className={`${styles.mobile_submenu} ${idx === numItem ? 'active' : ''}`}>
                      <ul className={styles.mobile_submenu_menu}>
                        {menu.map((el, idx) => {
                          const { title, link } = el;
                          const isLink = isExternalLink(link);
                          return isLink ? (
                            <li key={idx} className={styles.mobile_submenu_link}>
                              <a href={link} target="_black" onClick={() => setIsMobMenu(false)} className={styles.mobile_submenu_link}>
                                {title[lang]}
                              </a>
                            </li>
                          ) : (
                            <li key={idx} className={styles.mobile_submenu_link}>
                              <NavLink to={l(link, lang)} onClick={() => setIsMobMenu(false)} className={styles.mobile_submenu_link}>
                                {title[lang]}
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
